import styled, { css } from 'styled-components';
import { switchProp, ifProp, ifNotProp } from 'styled-tools';

export const DIRECTIONS = {
  UP: 'UP',
  DOWN: 'DOWN',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
};

export const AXES = {
  // HORIZONTAL: 'HORIZONTAL', // Not currently supported
  VERTICAL: 'VERTICAL',
};

export const SPEEDS = { INSTANT: 'INSTANT', FAST: 'FAST', SLOW: 'SLOW' };

export const SPEED_TO_DURATION_MS = {
  [SPEEDS.INSTANT]: 0,
  [SPEEDS.FAST]: 150,
  [SPEEDS.SLOW]: 300,
};

export const DELAYS = {
  NONE: 'NONE',
  SHORTER: 'SHORTER',
  SHORT: 'SHORT',
  LONG: 'LONG',
};

export const DELAY_TO_DURATION_MS = {
  [DELAYS.NONE]: 0,
  [DELAYS.SHORTER]: 150,
  [DELAYS.SHORT]: 250,
  [DELAYS.LONG]: 500,
};

const makeDirectionTransforms = offsetStr => ({
  [DIRECTIONS.UP]: `transform: translateY(-${offsetStr});`,
  [DIRECTIONS.DOWN]: `transform: translateY(${offsetStr});`,
  [DIRECTIONS.LEFT]: `transform: translateX(-${offsetStr});`,
  [DIRECTIONS.RIGHT]: `transform: translateX(${offsetStr});`,
});

export const HideableBox = styled.div`
  display: flex;
  flex: 1 1 auto;
  transition-property: pointer-events, opacity, transform, height;
  will-change: pointer-events, opacity, transform, height;
  transition-duration: ${switchProp('speed', {
    [SPEEDS.FAST]: `${SPEED_TO_DURATION_MS[SPEEDS.FAST]}ms`,
    [SPEEDS.SLOW]: `${SPEED_TO_DURATION_MS[SPEEDS.SLOW]}ms`,
  })};
  transition-delay: ${props => DELAY_TO_DURATION_MS[props.delayIn] || 0}ms;

  ${ifNotProp(
    'visible',
    css`
      pointer-events: none;
      ${ifProp('fade', 'opacity: 0;')}
      ${props =>
        switchProp('nudge', makeDirectionTransforms(props.nudgeAmount))(props)}
      ${switchProp('slide', makeDirectionTransforms('100%'))}
      transition-delay: ${props => DELAY_TO_DURATION_MS[props.delayOut] || 0}ms;
    `
  )}
`;
